import { UIGeneralServicesController } from '../../shared/scripts/UIGeneralServicesController.ts';
import { UINotificationActionController } from '../../shared/scripts/notifications/UINotificationActionController.ts';
import { UIWOnlineFriendController } from './ui_friends/UIWOnlineFriendController.ts';
export class UIWGeneralServicesController extends UIGeneralServicesController {
    init() {
        var _this_onlineFriendController;
        (_this_onlineFriendController = this.onlineFriendController) === null || _this_onlineFriendController === void 0 ? void 0 : _this_onlineFriendController.init();
    }
    constructor(uiManager, uiHeaderController){
        super();
        this.onlineFriendController = new UIWOnlineFriendController(uiManager === null || uiManager === void 0 ? void 0 : uiManager.room, uiHeaderController === null || uiHeaderController === void 0 ? void 0 : uiHeaderController.notificationPanelController);
        if (!(uiHeaderController === null || uiHeaderController === void 0 ? void 0 : uiHeaderController.notificationPanelController)) return;
        this.notificationActionController = new UINotificationActionController(uiHeaderController.notificationPanelController);
    }
}
